import { createPromotionsModel } from './PromotionsModel';

export { SOCKET_ID } from './PromotionsModel';

export const promotionsModel = createPromotionsModel();
